import { HostMode, HostType } from '@repo/types/host';
import { WAND_HOST_MODE_HEADER, WAND_HOST_TYPE_HEADER } from './constants';

export type ResolvedHostContext = {
    hostType: HostType;
    hostMode: HostMode;
};

const KNOWN_HOST_TYPES = new Set<string>(Object.values(HostType));
const KNOWN_HOST_MODES = new Set<string>(Object.values(HostMode));

export function resolveHostContext(params: {
    hostType?: string | null;
    hostMode?: string | null;
}): ResolvedHostContext {
    return {
        hostType:
            params.hostType != null && KNOWN_HOST_TYPES.has(params.hostType)
                ? (params.hostType as HostType)
                : HostType.WEB,
        hostMode:
            params.hostMode != null && KNOWN_HOST_MODES.has(params.hostMode)
                ? (params.hostMode as HostMode)
                : HostMode.WINDOW,
    };
}

export function getHostContextFromHeaders(headers: Headers, url?: string | null): ResolvedHostContext {
    const fromHeaders = {
        hostType: headers.get(WAND_HOST_TYPE_HEADER),
        hostMode: headers.get(WAND_HOST_MODE_HEADER),
    };
    let fromQuery: { hostType: string | null; hostMode: string | null } = {
        hostType: null,
        hostMode: null,
    };

    if (url) {
        try {
            const parsed = new URL(url);
            fromQuery = {
                hostType: parsed.searchParams.get('hostType'),
                hostMode: parsed.searchParams.get('hostMode'),
            };
        } catch {
            // ignore invalid URLs (e.g. malformed referer)
        }
    }

    return resolveHostContext({
        hostType: fromQuery.hostType ?? fromHeaders.hostType,
        hostMode: fromQuery.hostMode ?? fromHeaders.hostMode,
    });
}

export function getHostContextFromRequest(request: Pick<Request, 'url' | 'headers'>): ResolvedHostContext {
    return getHostContextFromHeaders(request.headers, request.url);
}
